import { render, staticRenderFns } from "./CarrierAreaInfoCard.vue?vue&type=template&id=64e5a46c&scoped=true&"
import script from "./CarrierAreaInfoCard.vue?vue&type=script&lang=js&"
export * from "./CarrierAreaInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5a46c",
  null
  
)

export default component.exports